import type { IMyWorkAreasChange } from '@/services/WorkItemApi';
import { subscribeToMyWorkAreas as subscribe } from '@/services/workItemSubscriptions';
import { createPersonalStream, type PersonalStreamListener } from './personalStream';

/**
 * One tab's follow of `myWorkAreasChanges` (I-1525, `docs/concept-mobile-app.md` AC-19.19): the work
 * areas the signed-in person sees changed — one gained or lost, renamed, moved or deleted — so the
 * work-area menu re-reads them.
 *
 * Shared, reopened and resumed as every person's stream is (`personalStream.ts`). `ProjectStore`
 * calls {@link wakeMyWorkAreas} after each list it reads successfully, the proof that the tab has a
 * session.
 */
export type MyWorkAreasListener = PersonalStreamListener<IMyWorkAreasChange>;

const stream = createPersonalStream<IMyWorkAreasChange>((onChange, onError) =>
  subscribe(onChange, onError),
);

export function subscribeToMyWorkAreas(listener: MyWorkAreasListener): () => void {
  return stream.subscribe(listener);
}

/** Open the stream if a follower wants it and the tab now has a session. Cheap when already open. */
export function wakeMyWorkAreas(): void {
  stream.wake();
}

export function resetMyWorkAreasForTest(): void {
  stream.resetForTest();
}
